import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  QueryList,
  SimpleChanges,
  ViewChildren
} from "@angular/core";
import { assetUrl } from "@shared/helper/asset-url";

export type Comment = {
  message: string;
  userName: string;
  userType: string;
  date: string;
  expand?: boolean;
  showSeeMore?: boolean;
  imgUrl?: string;
};

@Component({
    selector: "app-driveb-thread",
    templateUrl: "./thread.component.html",
    styleUrls: ["./thread.component.scss"],
    standalone: false
})
export class ThreadComponent implements AfterViewInit, OnChanges {
  @Input() comments: Comment[];
  @ViewChildren("message") messageChildren: QueryList<
    ElementRef<HTMLDivElement>
  >;

  seeMoreOldest = false;

  defaultImgUrl = assetUrl("img/icons-driveb/thread-client.png");

  constructor(private cd: ChangeDetectorRef) {}

  get showComments(): Comment[] {
    if (!this.seeMoreOldest) {
      return this.newestComments;
    }
    return this.comments;
  }

  get newestComments(): Comment[] {
    return this.comments.slice(0, 3);
  }

  get oldestComments(): Comment[] {
    return this.comments.slice(3);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.comments.firstChange) {
      return;
    }

    setTimeout(() => {
      this.verifyShowSeeMore();
    }, 10);
  }

  ngAfterViewInit(): void {
    this.verifyShowSeeMore();
  }

  verifyShowSeeMore(): void {
    if (!this.messageChildren) {
      return;
    }

    this.messageChildren.forEach((element, i) => {
      this.comments[i].showSeeMore = this.commentHasSeeMore(element);
    });

    this.cd.detectChanges();
  }

  commentHasSeeMore(element: ElementRef<HTMLDivElement>): boolean {
    return (
      element.nativeElement.offsetHeight < element.nativeElement.scrollHeight
    );
  }

  handleClickSeeMoreComment(comment: Comment): void {
    comment.expand = true;
  }

  handleClickSeeMoreOldest(): void {
    this.seeMoreOldest = true;
    setTimeout(() => {
      this.verifyShowSeeMore();
    }, 10);
  }
}
